import { useState } from "react";
import { ArrowRight, Lock } from "lucide-react";
import { FadeIn } from "./Motion";

const API = process.env.REACT_APP_BACKEND_URL;
export const STATS_KEY = "hv_stats_key";

export const useUnlocked = () => {
  const [pw, setPw] = useState(() => sessionStorage.getItem(STATS_KEY) || "");
  const lock = () => { sessionStorage.removeItem(STATS_KEY); setPw(""); };
  return { pw, setPw, lock };
};

export const PasswordGate = ({ title, description, onUnlock }) => {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    const r = await fetch(`${API}/api/stats/verify`, { headers: { "X-Stats-Key": pw } });
    if (r.ok) { sessionStorage.setItem(STATS_KEY, pw); onUnlock(pw); }
    else setErr("That password didn't match.");
  };
  return (
    <FadeIn className="max-w-md mx-auto px-5 py-28">
      <div className="rounded-[2rem] border border-[#E8DDD3] bg-white p-8 sm:p-10 shadow-[0_40px_80px_-30px_rgba(31,26,23,0.25)]">
        <span className="h-11 w-11 rounded-xl grid place-items-center bg-[#1F1A17] text-[#FBF8F4]"><Lock className="h-4 w-4" /></span>
        <h1 className="mt-6 font-serif text-3xl tracking-tight text-[#1F1A17]">{title}</h1>
        <p className="mt-2 text-sm text-[#685F58]">{description}</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input
            type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Password" autoFocus
            data-testid="stats-password-input"
            className="w-full h-12 rounded-full border border-[#E8DDD3] bg-[#FBF8F4] px-5 text-sm text-[#1F1A17] outline-none focus:border-[#1F1A17]"
          />
          {err && <p className="text-sm text-[#B4532A]" data-testid="stats-password-error">{err}</p>}
          <button type="submit" data-testid="stats-password-submit" className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#B4532A] hover:bg-[#9C421E] h-12 text-sm font-medium text-[#FBF8F4] transition-colors duration-300">
            Unlock <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </form>
      </div>
    </FadeIn>
  );
};
